module.exports = __webpack_public_path__ + "img/41.70d8dc08.gif";